import * as React from "react";
import Tile from "./elements/Tile";
import Top from "./elements/Top";
import Bottom from "./elements/Bottom";
import { Title, Subtitle, Meta } from "./elements/Typo";
import { RegistrationStatus } from "./types";
import Icon from "../../elements/Icon";
import ActivityTypeTag from "./elements/ActivityTypeTag";

type Texts = {
  activityType: string;
  activities: string;
  notStarted: string;
  finished: string;
  hoverButton?: string;
};

const DEFAULT_TEXTS: Texts = {
  activityType: "Learning playlist",
  activities: "onderdelen",
  notStarted: "Nog niet begonnen",
  finished: "Afgerond",
  hoverButton: "Aan de slag"
};

type Props = {
  style?: React.CSSProperties;
  className?: string;
  imageSrc: string;
  title: string;
  supplier: string;
  onClick?: () => void;
  texts?: Texts;
  nrOfActivities: number;
  progress?: number;
  status?: RegistrationStatus;
  showProgress?: boolean;
};

function PlaylistTile(
  // @ts-ignore
  {
    style,
    className,
    imageSrc,
    title,
    supplier,
    onClick,
    progress,
    nrOfActivities,
    texts = DEFAULT_TEXTS,
    status,
    showProgress = true
  }: Props,
  ref: any
) {
  let contentBottomLeft = null;
  if (!showProgress) {
    contentBottomLeft = null;
  } else if (status === "COMPLETED") {
    contentBottomLeft = (
      <>
        <Icon
          name="finished"
          c={["success", 5]}
          size={14}
          style={{ marginRight: 4 }}
        />
        <Meta>{texts.finished}</Meta>
      </>
    );
  } else if (!progress) {
    contentBottomLeft = <Meta>{texts.notStarted}</Meta>;
  } else {
    contentBottomLeft = <Meta>{Math.round(progress)}%</Meta>;
  }

  const [isOver, setOver] = React.useState(false);

  return (
    <Tile
      playlist
      ref={ref}
      style={style}
      className={className}
      onClick={onClick}
      showProgressBar
      progress={progress}
      onMouseOverChange={setOver}
    >
      <Top imageSrc={imageSrc}>
        <ActivityTypeTag iconName="playlists" text={texts.activityType} />
      </Top>
      <Bottom
        topLeft={
          <>
            <Title>{title}</Title>
            <Subtitle>{supplier}</Subtitle>
          </>
        }
        bottomLeft={contentBottomLeft}
        bottomRight={
          <Meta>
            {nrOfActivities} {texts.activities}
          </Meta>
        }
        isOver={isOver}
        HoverButtonText={status !== "COMPLETED" && texts.hoverButton}
      />
    </Tile>
  );
}

export default React.memo(React.forwardRef(PlaylistTile), (prev, next) => {
  if (prev.title !== next.title) {
    return false;
  }

  if (prev.supplier !== next.supplier) {
    return false;
  }

  if (prev.imageSrc !== next.imageSrc) {
    return false;
  }

  return true;
});
